/**
 * Datadog RUM Headers Extraction
 */

/**
 * Extracts Datadog RUM configuration from request headers
 * @param {Object} headers - Request headers object
 * @returns {Object} Datadog RUM credentials (applicationId, clientToken) or null
 */
export const extractDatadogRumFromHeaders = headers => {
  if (!headers) return null

  const applicationId = headers['x-dd-app-id'] ?? ''
  const clientToken = headers['x-dd-token'] ?? ''

  // Return null if credentials are missing
  if (!applicationId || !clientToken) return null

  return {
    applicationId,
    clientToken
  }
}
